/* eslint-disable no-new */
import KeenSlider from "keen-slider";
import { useVariantPrice } from "../../olipop/utilities/money";

export const rebuyUpsellSmartCartSlider = () => {
  document.addEventListener("rebuy.ready", (event) => {
    const RebuySmartCartCrossSells =
      window.Rebuy?.SmartCart?.settings?.cross_sells;

    if (!RebuySmartCartCrossSells) return;

    if (
      event.detail.widget?.id &&
      RebuySmartCartCrossSells.includes(event.detail.widget.id)
    ) {
      const rebuyContainerEl = document.querySelector(".rebuy-upsell");
      // Container styling
      rebuyContainerEl.classList.add(
        "tw-py-4",
        "tw-pl-5",
        "tw-w-full",
        "tw-border-b",
        "tw-border-hunter-green/25",
        "tw-border-solid"
      );

      // Arrow Container
      const titleContainerEl = document.createElement("div");
      titleContainerEl.classList.add(
        "tw-flex",
        "tw-justify-between",
        "tw-items-center",
        "tw-pb-3",
        "tw-pr-5"
      );
      rebuyContainerEl.appendChild(titleContainerEl);

      // Widget Title
      const widgetTitle = event.detail.widget.data.config.language.title;
      const newWidgetTitle = document.createElement("div");
      const widgetTitleContent = document.createTextNode(widgetTitle);
      newWidgetTitle.appendChild(widgetTitleContent);
      newWidgetTitle.classList.add(
        "tw-text-[14px]",
        "tw-font-semibold",
        "tw-leading-[14px]",
        "tw-pr-2",
        "tw-flex-1"
      );
      titleContainerEl.appendChild(newWidgetTitle);

      // Arrow Container
      const arrowContainerEl = document.createElement("div");
      arrowContainerEl.classList.add("tw-flex", "tw-items-center");
      titleContainerEl.appendChild(arrowContainerEl);

      // Arrow Right SVG
      const arrowRightEl = document.createElement("button");
      arrowRightEl.classList.add(
        "tw-flex",
        "tw-bg-transparent",
        "tw-w-[14px]",
        "tw-h-[14px]",
        "tw-p-0",
        "tw-border-none"
      );
      arrowRightEl.id = "arrow-right";
      arrowRightEl.ariaLabel = "Slider next button";
      arrowRightEl.innerHTML = `<svg class="arrow--right tw-bg-transparent tw-rotate-180" width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3.5 1.875L9.625 8L3.5 14.125" stroke="#14433D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      `;
      arrowContainerEl.appendChild(arrowRightEl);
      const arrowRight = rebuyContainerEl.querySelector("#arrow-right");

      // Arrow Left SVG
      const arrowLeftEl = document.createElement("button");
      arrowLeftEl.classList.add(
        "tw-flex",
        "tw-bg-transparent",
        "tw-w-[14px]",
        "tw-h-[14px]",
        "tw-p-0",
        "tw-border-none",
        "tw-ml-10"
      );
      arrowLeftEl.id = "arrow-left";
      arrowLeftEl.ariaLabel = "Slider previous button";
      arrowLeftEl.innerHTML = `<svg class="arrow--left tw-bg-transparent" width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3.5 1.8833L9.625 8.0083L3.5 14.1333" stroke="#14433D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>`;
      arrowContainerEl.appendChild(arrowLeftEl);
      const arrowLeft = rebuyContainerEl.querySelector("#arrow-left");

      // Products Wrapper
      const productsWrapper = document.createElement("div");
      productsWrapper.classList.add("keen-slider");
      rebuyContainerEl.appendChild(productsWrapper);

      const renderProducts = (productsArray) => {
        // Clear previous products
        productsWrapper.innerHTML = "";

        productsArray.forEach((product) => {
          // Product Container
          const productContainer = document.createElement("div");
          productContainer.classList.add(
            "tw-p-2",
            "tw-rounded-[10px]",
            "tw-border",
            "tw-border-solid",
            "tw-border-hunter-green/25",
            "tw-bg-white",
            "tw-flex",
            "tw-items-center",
            "keen-slider__slide"
          );
          productsWrapper.appendChild(productContainer);

          // Product Image
          const productImageEl = document.createElement("img");
          productImageEl.src = product.image.src;
          productImageEl.alt = product.title;
          productImageEl.classList.add(
            "product-image",
            "tw-w-[26px]",
            "tw-h-12",
            "tw-mr-2",
            "tw-object-contain"
          );
          productContainer.appendChild(productImageEl);

          // Product Title & price wrapper
          const productInfoWrapperEl = document.createElement("div");
          productInfoWrapperEl.classList.add(
            "product-info-wrapper",
            "tw-flex",
            "tw-flex-col",
            "tw-justify-center",
            "tw-flex-1"
          );
          productContainer.appendChild(productInfoWrapperEl);

          // Product Title
          const newProductsEl = document.createElement("div");
          const productTitle = document.createTextNode(product.title);
          newProductsEl.appendChild(productTitle);
          newProductsEl.classList.add(
            "product-title",
            "tw-text-3",
            "tw-font-semibold",
            "tw-leading-3",
            "tw-pb-2"
          );
          productInfoWrapperEl.appendChild(newProductsEl);
          // Product Price
          const productPriceContainer = document.createElement("div");
          const variantMoney = useVariantPrice(product.variants[0]);
          const productPrice = document.createElement("div");
          productPrice.innerHTML = `${variantMoney.price.withoutTrailingZeros()}`;
          productPriceContainer.appendChild(productPrice);
          if (variantMoney.compareAtPrice) {
            const productCompareAtPrice = document.createElement("s");
            productCompareAtPrice.classList.add("tw-font-normal");
            productCompareAtPrice.innerHTML = `${variantMoney.compareAtPrice.withoutTrailingZeros()}`;
            productPriceContainer.appendChild(productCompareAtPrice);
          }
          productPriceContainer.classList.add(
            "product-price",
            "tw-text-3",
            "tw-font-semibold",
            "tw-leading-3",
            "tw-flex",
            "tw-gap-x-1.5"
          );

          productInfoWrapperEl.appendChild(productPriceContainer);

          // Product Add button
          const addButtonEl = document.createElement("button");
          const addButtonLanguage = document.createTextNode(
            event.detail.widget.data.config.language.add_to_cart
          );
          addButtonEl.appendChild(addButtonLanguage);
          addButtonEl.classList.add(
            "tw-text-white",
            "tw-bg-hunter-green",
            "tw-rounded-[100px]",
            "tw-py-2",
            "tw-px-3",
            "tw-font-semibold",
            "tw-border-none",
            "tw-font-body",
            "tw-text-3",
            "tw-leading-3"
          );

          addButtonEl.onclick = function () {
            // Set the loading spinner as the button content
            addButtonEl.innerHTML = `<svg class="tw-animate-spin tw-h-5 tw-w-5 tw-text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle class="tw-opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="tw-opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
            </svg>`;

            window.Rebuy.widgets
              .find((widget) => widget.id === event.detail.widget.id)
              .addToCart(product);

            productChangeEvent();
          };
          productContainer.appendChild(addButtonEl);
        });

        // Re-initiate Keen Slider
        new KeenSlider(productsWrapper, {
          loop: true,
          breakpoints: {
            "(min-width: 750px)": {
              slides: {
                perView: 2.1,
                spacing: 8,
              },
            },
          },
          slides: {
            perView: 1.7,
            spacing: 8,
          },
          created: function (slide) {
            arrowRight.addEventListener("click", function () {
              slide.prev();
            });

            arrowLeft.addEventListener("click", function () {
              slide.next();
            });
          },
        });
      };

      function productChangeEvent() {
        document.addEventListener("rebuy.productsChange", function (event) {
          renderProducts(event.detail.products);
        });
      }

      renderProducts(event.detail.widget.data.products);
      productChangeEvent();
    }
  });
};
